module.exports = __webpack_public_path__ + "img/hero.d1bb40cf.png";